import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { useTypewriter } from '../hooks/useTypewriter';

const AnimatedMarkdown = ({ text, isStreaming }) => {
    const animatedText = useTypewriter(text);
    const displayedText = isStreaming ? animatedText : text;

    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
        >
            {displayedText}
        </ReactMarkdown>
    );
};

export default AnimatedMarkdown;
